import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SeriesCardComponent.css';
import placeholderImage from '../../assets/card_placeholder.png';

const SeriesCardComponent = ({ series, anime, onSelectAnime, currentId, single, canWatch = true }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const imgRef = useRef(null);
    const navigate = useNavigate();
    const [hideSeriesPreviewEnabled, setHideSeriesPreview] = useState(localStorage.getItem("hideSeriesPreview"));
    const isLocked = !canWatch;

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !imageLoaded) {
                    loadImage();
                    observer.unobserve(entry.target);
                }
            });
        });

        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => {
            if (imgRef.current) {
                observer.unobserve(imgRef.current);
            }
        };
    }, [imageLoaded]);

    const loadImage = () => {
        const imgElement = imgRef.current;
        const API_DOMAIN = 'https://api.whitewhale.help';

        if (imgElement) {
            const animixPreview = series.privateId
                ? `${API_DOMAIN}/anime/getThumb/${series.privateId}_thumb.png`
                : null;
            const previewCandidates = series.kodikOnly
                ? [series.kodikPreviewUrl, placeholderImage]
                : [animixPreview, series.kodikPreviewUrl, placeholderImage];
            const sources = previewCandidates.filter(Boolean);
            let sourceIndex = 0;

            imgElement.onerror = () => {
                sourceIndex += 1;
                if (sourceIndex < sources.length) {
                    imgElement.src = sources[sourceIndex];
                }
            };
            imgElement.src = sources[0] || placeholderImage;
            imgElement.onload = () => {
                setImageLoaded(true);
            };
        }

    };

    const handleSeriesClick = () => {
        if (!canWatch) {
            return;
        }
        navigate(`/watch/${anime.id}/${series.id}`);
        if (onSelectAnime != null) {
            onSelectAnime(series);
        }
    };

    return (
        <div className={`series-card${isLocked ? ' locked' : ''}${series.kodikOnly ? ' kodik-only' : ''}`} onClick={handleSeriesClick}>
            <img
                ref={imgRef}
                alt={series.name}
                className={`series-thumbnail ${imageLoaded ? 'loaded' : ''} ${currentId != null ? (String(currentId) === String(series.id) ? 'current' : '') : ''}
                 ${hideSeriesPreviewEnabled != null ? (hideSeriesPreviewEnabled === "true" ? 'blur' : '') : ''}`}
            />
            {series.kodikOnly ? <span className="series-source-badge">Kodik</span> : null}
            <p className={`series-subname ${currentId ? (String(currentId) === String(series.id) && !single ? 'active' : '') : ''}`}>Текущая серия</p>
            <h4 className="series-name">{!single ? 'Серия ' + series.seriesNum : 'Фильм'}</h4>
        </div>
    );
};

export default SeriesCardComponent;
